export default {
    name: 'LoginModule',
};
